/* eslint-disable no-nested-ternary */
import dayjs from 'dayjs';
import React, { Fragment } from 'react';
import { Summary as OrderSummary } from '|/app/services';
import * as Summary from '|/app/steps/order-summary/order-summary-components.styles';
import {
  DateTimeBoxWrapper,
  DateTimeBox,
  DateTimeLabel
} from '|/app/steps/order-summary/sections/delivery-details-section/delivery-details-section.styles';
import useOrderSummaryVm from '|/helpers/use-order-summary';

dayjs.extend(require('dayjs/plugin/customParseFormat'));

const defaultProps = {
  summary: {} as OrderSummary
};

const DeliveryAddressDateTimeSection = ({ summary } = defaultProps) => {
  const {
    hasTransferMethod,
    isPickup,
    isDelivery,
    hasScheduledDate,
    scheduledTime,
    hasTimeWindows,
    windowStartTime,
    windowEndTime,
    timezone,
    transferAddress: address
  } = useOrderSummaryVm(summary);

  return (
    <Summary.Box>
      {!hasTransferMethod && (
        <Summary.BoxText>
          * We still need your delivery or pick-up selection
        </Summary.BoxText>
      )}

      {hasTransferMethod && (
        <Fragment>
          <Summary.BoxLabel>
            {' '}
            {isDelivery ? 'Delivery' : isPickup ? 'Pick-Up' : null} Address
          </Summary.BoxLabel>
          <Summary.BoxText>
            {`${address?.line1} ${address?.line2 ? address?.line2 : ''}`}{' '}
          </Summary.BoxText>
          <Summary.BoxText>
            {address?.city}, {address?.state} {address?.zipCode}
          </Summary.BoxText>
          {hasScheduledDate && (
            <DateTimeBoxWrapper>
              {hasTimeWindows ? (
                <>
                  <DateTimeBox>
                    <DateTimeLabel>Date</DateTimeLabel>
                    <Summary.BoxText>
                      {dayjs(scheduledTime).format('MMM DD, YYYY')}
                    </Summary.BoxText>
                  </DateTimeBox>
                  <DateTimeBox>
                    <DateTimeLabel>Time Window</DateTimeLabel>
                    <Summary.BoxText>
                      {`Between ${dayjs(
                        windowStartTime,
                        'YYYY-MM-DDTHH:mm:ss'
                      ).format('ha')} -
                      ${dayjs(windowEndTime, 'YYYY-MM-DDTHH:mm:ss').format(
                        'ha'
                      )} ${timezone}`}
                    </Summary.BoxText>
                  </DateTimeBox>
                </>
              ) : (
                <>
                  <DateTimeBox>
                    <DateTimeLabel>Date</DateTimeLabel>
                    <Summary.BoxText>
                      {dayjs(scheduledTime).format('MMM DD, YYYY')}
                    </Summary.BoxText>
                  </DateTimeBox>
                  <DateTimeBox>
                    <DateTimeLabel>Time</DateTimeLabel>
                    <Summary.BoxText>
                      {`${dayjs(scheduledTime, 'YYYY-MM-DDTHH:mm:ss')?.format(
                        'h:mm A'
                      )} ${timezone}`}
                    </Summary.BoxText>
                  </DateTimeBox>
                </>
              )}
            </DateTimeBoxWrapper>
          )}
        </Fragment>
      )}
    </Summary.Box>
  );
};

export default DeliveryAddressDateTimeSection;
